import { InjectionToken } from '@angular/core';

export const VERSION_CHECK_POLLING_INTERVAL = new InjectionToken<string>('POLLING_INTERVAL');
